import { formats } from "./AddressFormats";
var states = formats.CA.states.map(function (_ref) {
  var label = _ref.name,
      value = _ref.code;
  return {
    label: label,
    value: value
  };
});
export default states;